__turbopack_context__.v({
  "accent": "step-black-waitlist-module-scss-module__6lynTq__accent",
  "already-have": "step-black-waitlist-module-scss-module__6lynTq__already-have",
  "control": "step-black-waitlist-module-scss-module__6lynTq__control",
  "error-container": "step-black-waitlist-module-scss-module__6lynTq__error-container",
  "error-message": "step-black-waitlist-module-scss-module__6lynTq__error-message",
  "form": "step-black-waitlist-module-scss-module__6lynTq__form",
  "heading": "step-black-waitlist-module-scss-module__6lynTq__heading",
  "message": "step-black-waitlist-module-scss-module__6lynTq__message",
  "responsive-image": "step-black-waitlist-module-scss-module__6lynTq__responsive-image",
  "submit": "step-black-waitlist-module-scss-module__6lynTq__submit",
  "success-container": "step-black-waitlist-module-scss-module__6lynTq__success-container",
  "success-message": "step-black-waitlist-module-scss-module__6lynTq__success-message",
  "supporting-text": "step-black-waitlist-module-scss-module__6lynTq__supporting-text",
  "title": "step-black-waitlist-module-scss-module__6lynTq__title",
});
